<template>
  <Loading v-if="isLoading" />
  <div v-else>
    <popup-add-tip-percent ref="popupAddTipPercent" type="Stock" />
    <div class="flex justify-between">
      <p>This sets the tip configuration used in the REKOM POS client.</p>
      <div class="flex justify-end">
        <vs-button
          icon="add"
          @click="$refs.popupAddTipPercent.show()"
          type="relief"
          color="primary"
          class="mr-3"
          >Add tip percent</vs-button
        >
      </div>
    </div>
    <!-- table -->
    <div class="data-list-list-view">
      <vs-table ref="table" class="mt-4" :max-items="50" :data="tipPercentages">
        <template slot="thead">
          <vs-th sort-key="name">Percentage</vs-th>
          <vs-th sort-key="action">Action</vs-th>
        </template>

        <template slot-scope="{ data }">
          <tbody>
            <vs-tr>
              <vs-td> 0% </vs-td>
              <vs-td> </vs-td>
            </vs-tr>
            <vs-tr :data="tr" :key="idx" v-for="(tr, idx) in data">
              <vs-td> {{ tr }}% </vs-td>
              <vs-td>
                <feather-icon
                  icon="TrashIcon"
                  svgClasses="w-5 h-5 hover:text-danger stroke-current"
                  class="ml-4"
                  @click.stop="confirmDelete(tr)"
                />
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </div>
    <!-- Save & Remove Button -->
    <vs-row>
      <vs-button id="save-button" @click="saveChanges" class="mt-4"
        >Save Changes</vs-button
      >
    </vs-row>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import ProductIcon from "@/assets/images/product-icon.png";
import popupAddTipPercent from "./PopupAddTipPercent.vue";

export default {
  components: { popupAddTipPercent },
  data() {
    return {
      isLoading: false,
      toDelete: null,
      ProductIcon,
    };
  },
  methods: {
    confirmDelete(id) {
      this.toDelete = id;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Delete tip percent",
        text: "Are you sure you want to delete this tip percent?",
        accept: this.deletetipPercent,
      });
    },
    async saveChanges() {
      this.$vs.loading();
      await this.$store.dispatch("pos/countrySettings/updateCountrySettings");
      this.$vs.loading.close();
    },
    deletetipPercent() {
      this.$store.commit("pos/countrySettings/deleteTipPercent", this.toDelete);
      this.toDelete = null;
    },
    async onClickCreateNew() {
      this.$refs.popupEditTipPercent.show();
    },
  },
  computed: {
    ...mapGetters({
      tipPercentages: "pos/countrySettings/tipPercentages",
    }),
  },

  async created() {},
};
</script>